export default {
    report_export_history: 'Historial de Exportación',
    report_export_history_report: 'Reporte',
    report_export_history_created_on: 'Creado En',
    report_export_history_status: 'Estado',
    report_export_history_status_updated_on: 'Estado Actualizado En',
    report_export_history_type: 'Tipo',
    report_export_history_processed_records: 'Registros Procesados',
    report_export_history_total: 'Total',
    report_export_history_error_message: 'Mensaje de Error',
    report_export_history_output_url: 'Descargar',
    report_export_history_date_range: 'Por favor selecciona un rango de fechas',
    report_export_history_download_error: 'No fue posible preparar la descarga del archivo',
    report_export_history_download_unavailable: 'El archivo no está disponible para descarga',
    report_export_history_status_completed: 'Completado',
    report_export_history_status_pending: 'Pendiente',
    report_export_history_status_processing: 'Procesando',
    report_export_history_status_in_progress: 'En progreso',
    report_export_history_status_failed: 'Fallido',
    report_export_history_status_error: 'Error',
    report_export_history_status_cancelled: 'Cancelado',
};
